import React from 'react';
import PropTypes from 'prop-types';

import config from '../../config';
import logoImage from './swimmy-logo.png';
import mobileLogoImage from './swimmy-mobile-logo.png';

const Logo = props => {
  const { className, format, ...rest } = props;

  if (format === 'desktop') {
    return <img className={className} src={logoImage} alt={config.siteTitle} {...rest} />;
  }

  return <img className={className} src={mobileLogoImage} alt={config.siteTitle} {...rest} />;
};

const { oneOf, string } = PropTypes;

Logo.defaultProps = {
  className: null,
  format: 'desktop',
};

Logo.propTypes = {
  className: string,
  format: oneOf(['desktop', 'mobile']),
};

export default Logo;
